/* @jsxImportSource react */

import type { ReactNode } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { UseDisplayModeFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseDisplayModeFragmentFragmentDoc';
import { ProductCardGrid } from '@packages/modules/src/ProductCardV2/ProductCardV2.Grid';

import { useDisplayMode } from '../../hooks/useDisplayMode';

export const ProductListGrid = ({
  maskedResult,
  children,
}: {
  maskedResult: FragmentType<typeof UseDisplayModeFragmentFragmentDoc>;
  children: ReactNode;
}) => {
  const { displayMode } = useDisplayMode(maskedResult);
  return (
    // NOTE to work properly with "more information" and highlight cards, these values must be synced to the CSS values in default-globals.css, for the `product-card-grid` class, specifically the media queries for "more information" and "highlight cards" that need to be hardcoded
    <ProductCardGrid defaultMinCardWidth={displayMode === 'largeCards' ? '16rem' : '10.5rem'}>
      {children}
    </ProductCardGrid>
  );
};
